import React from "react";
import { motion } from "framer-motion";
import { HOME_JOURNEY } from "../data/content";

export const HowItWorks = () => {
  return (
    <section id="come-funziona" className="py-20 sm:py-28 bg-[#F9FAFB]" data-testid="how-it-works-section">
      <div className="mx-auto max-w-7xl px-5 sm:px-8">
        <div className="max-w-2xl">
          <span className="text-sm font-bold uppercase tracking-[0.2em] text-brand">Come Funziona</span>
          <h2 className="mt-3 font-heading text-3xl sm:text-4xl font-bold tracking-tight text-brand-deep">
            Dal QR Code al cliente che torna in negozio
          </h2>
          <p className="mt-4 font-body text-base sm:text-lg text-ink leading-relaxed">
            Un percorso semplice in 6 passaggi: così trasformi un visitatore di passaggio
            in un cliente che torna e acquista di nuovo.
          </p>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {HOME_JOURNEY.map((s, i) => (
            <motion.div
              key={s.step}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.08 }}
              className="relative rounded-3xl bg-white p-7 border border-gray-100 shadow-sm transition-all duration-300 hover:-translate-y-1 hover:shadow-xl hover:shadow-brand/5"
              data-testid={`how-step-${s.step}`}
            >
              <span className="font-heading text-5xl font-extrabold text-brand-light">{s.step}</span>
              <h3 className="mt-3 font-heading text-xl font-semibold text-brand-deep">{s.title}</h3>
              <p className="mt-2 font-body text-ink leading-relaxed">{s.text}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
